<p-inputGroup>
  <p-inputGroupAddon>{{ addonText() }}</p-inputGroupAddon>
  <input
    type="text"
    pInputText
    [placeholder]="placeholder()"
    [(ngModel)]="value"
  />
</p-inputGroup>
